module.exports = __webpack_public_path__ + "img/html.ca9e6d49.svg";